var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6024 2.18164H16.4009C19.3891 2.18164 21.8201 4.61264 21.82 7.60057V16.3991C21.82 19.387 19.3891 21.818 16.4009 21.818H7.6024C4.61447 21.818 2.18359 19.3871 2.18359 16.3991V7.60057C2.18359 4.61264 4.61447 2.18164 7.6024 2.18164ZM16.401 20.0758C18.4284 20.0758 20.0778 18.4265 20.0778 16.3991H20.0777V7.60057C20.0777 5.5733 18.4283 3.92387 16.4009 3.92387H7.6024C5.57514 3.92387 3.92583 5.5733 3.92583 7.60057V16.3991C3.92583 18.4265 5.57514 20.0759 7.6024 20.0758H16.401ZM6.85892 11.9999C6.85892 9.16406 9.16596 6.85697 12.0018 6.85697C14.8376 6.85697 17.1446 9.16406 17.1446 11.9999C17.1446 14.8357 14.8376 17.1427 12.0018 17.1427C9.16596 17.1427 6.85892 14.8357 6.85892 11.9999ZM8.62976 11.9998C8.62976 13.8591 10.1425 15.3717 12.0018 15.3717C13.861 15.3717 15.3738 13.8591 15.3738 11.9998C15.3738 10.1404 13.8612 8.62772 12.0018 8.62772C10.1424 8.62772 8.62976 10.1404 8.62976 11.9998Z",
    fill: "#F2F7FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_473_4334",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6024 2.18164H16.4009C19.3891 2.18164 21.8201 4.61264 21.82 7.60057V16.3991C21.82 19.387 19.3891 21.818 16.4009 21.818H7.6024C4.61447 21.818 2.18359 19.3871 2.18359 16.3991V7.60057C2.18359 4.61264 4.61447 2.18164 7.6024 2.18164ZM16.401 20.0758C18.4284 20.0758 20.0778 18.4265 20.0778 16.3991H20.0777V7.60057C20.0777 5.5733 18.4283 3.92387 16.4009 3.92387H7.6024C5.57514 3.92387 3.92583 5.5733 3.92583 7.60057V16.3991C3.92583 18.4265 5.57514 20.0759 7.6024 20.0758H16.401ZM6.85892 11.9999C6.85892 9.16406 9.16596 6.85697 12.0018 6.85697C14.8376 6.85697 17.1446 9.16406 17.1446 11.9999C17.1446 14.8357 14.8376 17.1427 12.0018 17.1427C9.16596 17.1427 6.85892 14.8357 6.85892 11.9999ZM8.62976 11.9998C8.62976 13.8591 10.1425 15.3717 12.0018 15.3717C13.861 15.3717 15.3738 13.8591 15.3738 11.9998C15.3738 10.1404 13.8612 8.62772 12.0018 8.62772C10.1424 8.62772 8.62976 10.1404 8.62976 11.9998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_473_4334)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.0416761f1a84d1aa86c0dc71d658f637.svg";
export { ForwardRef as ReactComponent };